/* eslint import/prefer-default-export: "off" */
import moment from 'moment';

/**
 * Get a single value from interaction ore.
 * @param {Array} interaction
 * @param {String} key
 * @param {*} defaultVal
 */
const getOreValue = (interaction, key, defaultVal = '') => {
  if (Object.prototype.hasOwnProperty.call(interaction.ore, key)) {
    return (interaction.ore[key][0] && interaction.ore[key][0].value) || defaultVal;
  }
  return defaultVal;
};

/**
 * Get multiple values from interaction ore.
 * @param {Array} interaction
 * @param {String} key
 */
const getOreValues = (interaction, key) => {
  if (Object.prototype.hasOwnProperty.call(interaction.ore, key)) {
    return interaction.ore[key] || [];
  }
  return [];
};

/**
 * Get a prettier format for our originator if available.
 * @param {String} originator
 * @param {String} channelType
 */
const processOriginator = (originator, channelType) => {
  switch (channelType) {
    case 'whatsapp':
      return originator.match(/^([0-9]+)/) ? originator.match(/^([0-9]+)/)[1] : originator;
    default:
      return originator;
  }
};

/**
 * Process interaction data into a much simpler form.
 * @param {Array} interaction
 */
const processInteraction = interaction => {
  // Search api from django gives us date_created, absinthe on elixir dateCreated
  const dateCreated = interaction.dateCreated || interaction.date_created;

  return {
    id: interaction.id,
    threadId: interaction.threadId,
    originator: processOriginator(getOreValue(interaction, 'originators'), interaction.type),
    originatorType: getOreValues(interaction, 'originators')[0].type,
    datetime: moment(dateCreated),
    channel: interaction.type,
    displayName: getOreValue(interaction, 'display_name')[0] || '',
    message: getOreValue(interaction, 'message'),
    avatar: getOreValue(interaction, 'profile_image', null),
    images: getOreValues(interaction, 'image').map(img => img.value),
    audio: getOreValues(interaction, 'audio').map(aud => aud.value),
    audioTranscript: getOreValues(interaction, 'audio').map(aud => aud.additional),
    video: getOreValues(interaction, 'video').map(vid => vid.value),
    document: getOreValues(interaction, 'application').map(doc => doc.value),
    text: getOreValues(interaction, 'text').map(txt => txt.value),
    replies: getOreValues(interaction, 'reply'),
    comments: getOreValues(interaction, 'comment'),
    sentiment: getOreValue(interaction, 'sentiment'),
    inCount: interaction.inCount,
    outCount: interaction.outCount,
    sentBy: interaction.sentBy || '',
    onAirId: interaction.onAirId || null,
    parent: interaction.parent || null,
  };
};

const nl2br = str => str.replace(/(?:\r\n|\r|\n)/g, '<br />');

const makeHyperlinks = str => {
  const regex = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/g;
  return str.replace(regex, (match, $1) => `<a href="${$1}" target="_blank">${$1}</a>`);
};

const makeHashtags = str => {
  const regex = /\B(#[0-9a-zA-Z]+\b)/g;
  return str.replace(regex, (match, $1) => `<span class="hashtag">${$1}</span>`);
};

const makeMentions = str => {
  const regex = /\B(@[0-9a-zA-Z_]+\b)/g;
  return str.replace(regex, (match, $1) => `<span class="mention">${$1}</span>`);
};

export {
  getOreValue,
  getOreValues,
  processInteraction,
  processOriginator,
  nl2br,
  makeHyperlinks,
  makeHashtags,
  makeMentions,
};



// WEBPACK FOOTER //
// ./src/helpers/interaction.js